var _rect, _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecentlyjoinprofile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 67,
    height: 67,
    rx: 11,
    fill: "url(#paint0_linear_4819_3987)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4819_3987)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.5 51C43.165 51 51 43.165 51 33.5C51 23.835 43.165 16 33.5 16C23.835 16 16 23.835 16 33.5C16 43.165 23.835 51 33.5 51Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.8714 39.6954C47.3701 46.3023 40.9833 51 33.5 51H33.3086L23.54 41.2301L22.9043 39.9258L23.0349 37.2461L24.5989 34.5254L27.2267 33.1869L30.9741 33.1186L27.5849 29.7293L26.9826 27.6785L27.2984 25.5095L28.8263 23.687L31.3501 22.9043L33.8418 23.6665L49.8714 39.6954Z",
    fill: "url(#paint1_linear_4819_3987)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2548 33.1486C34.9928 33.1093 34.7281 33.0896 34.4632 33.0898H28.2363C26.8222 33.0898 25.466 33.6516 24.466 34.6516C23.4661 35.6515 22.9043 37.0077 22.9043 38.4219V39.9258C22.9045 40.3657 23.0793 40.7876 23.3904 41.0987C23.7015 41.4098 24.1234 41.5847 24.5634 41.5849H33.0447C32.2452 40.1672 32.0288 38.494 32.4413 36.9195C32.8538 35.345 33.8628 33.9929 35.2548 33.1493V33.1486Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.494 30.5028C36.2319 28.7649 36.2319 25.9472 34.494 24.2093C32.7561 22.4714 29.9384 22.4714 28.2005 24.2093C26.4626 25.9472 26.4626 28.7649 28.2005 30.5028C29.9384 32.2407 32.7561 32.2407 34.494 30.5028Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5076 32.9203C37.4025 32.9203 36.3222 33.248 35.4033 33.862C34.4844 34.476 33.7682 35.3487 33.3453 36.3697C32.9223 37.3907 32.8117 38.5142 33.0273 39.5981C33.2429 40.682 33.7751 41.6777 34.5565 42.4591C35.338 43.2406 36.3336 43.7727 37.4175 43.9883C38.5014 44.2039 39.6249 44.0933 40.6459 43.6704C41.667 43.2475 42.5396 42.5313 43.1536 41.6124C43.7676 40.6935 44.0953 39.6132 44.0953 38.508C44.0953 37.0261 43.5066 35.6048 42.4587 34.5569C41.4108 33.509 39.9896 32.9203 38.5076 32.9203ZM41.123 41.4769C41.0412 41.5588 40.9439 41.6238 40.8369 41.6682C40.7299 41.7125 40.6151 41.7354 40.4993 41.7354C40.3834 41.7354 40.2687 41.7125 40.1617 41.6682C40.0546 41.6238 39.9574 41.5588 39.8755 41.4769L37.8842 39.4856C37.8022 39.4036 37.7372 39.3063 37.6929 39.1992C37.6485 39.0921 37.6257 38.9773 37.6258 38.8614V35.816C37.6322 35.5863 37.7279 35.3681 37.8927 35.2079C38.0574 35.0477 38.2782 34.9581 38.508 34.9581C38.7378 34.9581 38.9585 35.0477 39.1233 35.2079C39.288 35.3681 39.3837 35.5863 39.3901 35.816V38.4964L41.123 40.2293C41.205 40.3112 41.27 40.4084 41.3144 40.5155C41.3587 40.6225 41.3816 40.7372 41.3816 40.8531C41.3816 40.9689 41.3587 41.0837 41.3144 41.1907C41.27 41.2977 41.205 41.395 41.123 41.4769Z",
    fill: "url(#paint2_linear_4819_3987)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5 16C23.8354 16 16 23.8354 16 33.5C16 43.1646 23.8354 51 33.5 51C43.1646 51 51 43.1646 51 33.5C51 23.8354 43.1646 16 33.5 16ZM44.5694 44.5694C41.6336 47.5052 37.6518 49.1545 33.5 49.1545C29.3482 49.1545 25.3664 47.5052 22.4306 44.5694C19.4948 41.6336 17.8455 37.6518 17.8455 33.5C17.8455 29.3482 19.4948 25.3664 22.4306 22.4306C25.3664 19.4948 29.3482 17.8455 33.5 17.8455C37.6518 17.8455 41.6336 19.4948 44.5694 22.4306C47.5052 25.3664 49.1545 29.3482 49.1545 33.5C49.1545 37.6518 47.5052 41.6336 44.5694 44.5694Z",
    fill: "url(#paint3_linear_4819_3987)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.5351 58.0375L44.548 57.0752L44.5479 57.0749L45.5351 58.0375Z",
    fill: "#377DE2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4819_3987",
    x1: 33.5,
    y1: 0,
    x2: 33.5,
    y2: 67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7705",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60000",
    stopOpacity: 0.08
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4819_3987",
    x1: 24.3788,
    y1: 28.1358,
    x2: 43.9959,
    y2: 47.7529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1C9C9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4819_3987",
    x1: 38.5076,
    y1: 32.9203,
    x2: 38.5076,
    y2: 44.0957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7705",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60000",
    stopOpacity: 0.81
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4819_3987",
    x1: 33.5,
    y1: 16,
    x2: 33.5,
    y2: 51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7705",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60000",
    stopOpacity: 0.81
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4819_3987"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecentlyjoinprofile);
export default __webpack_public_path__ + "static/media/RECENTLYJOINPROFILE.06b7095838b67bcc99a792001c706d78.svg";
export { ForwardRef as ReactComponent };